<template>
    <div>
        <input type="checkbox" class="checkbox" v-model="cropValue" :value="crop.id" @change="changeCropValue">
        <span class="label_title ">{{crop.name}}</span>
    </div>
</template>

<script>
export default {
    props: ['crop'],
    data() {
        return {
            cropValue: ''
        }
    },
    methods: {
        changeCropValue() {
            // console.log('crop ', this.crop)
            this.$emit('cropValue', this.crop.name)
        }
    }
}
</script>

<style>

</style>